import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { shouldAddOptionalPhoneNumber } from '../../step-code-verification/shouldRemoveOptionalPhoneNumber';
import { Step } from 'signup-constants/Step';
export const BranchOptionalPhoneNumber = {
  name: 'BranchOptionalPhoneNumber',
  stateCheck: shouldAddOptionalPhoneNumber,
  rebuildFlow: (flow, state, dispatch) => dispatch(FlowStateManager.replaceStep(Step.CompanyDomain, Step.CompanyDomain, Step.OptionalPhoneNumber)),
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};